module.exports = __webpack_public_path__ + "static/media/Coupon-active.7c91ceea.svg";